// Ofitsiantlar so'ragan hisob cheklari (Q-067): "ofitsiant cheklari" yoqilgan kassa navbatni har 5 soniyada tekshiradi
// va chekni o'z printeridan chiqaradi. Kassa qulflangan bo'lsa ham ishlaydi (xodim sessiyasi shart emas).
// Chiqmasa — navbatga qaytadi (boshqa kassa yoki keyingi urinish), ofitsiant telefonida holat ko'rinadi.
import { useEffect, useRef } from 'react';
import { deviceApi, withTimeout } from './device';
import type { OrderJson } from './logic';
import { printWaiterBill, usePrinter } from './printer';
import { useKassa } from './store';

interface Job {
  id: string;
  requested_by: string | null;
  order: OrderJson;
}

export function WaiterBills() {
  const { boot, settings } = useKassa();
  const printer = usePrinter();
  const on =
    Boolean(boot) &&
    (boot?.terminal.kind === 'pos' || boot?.terminal.kind === 'manager') &&
    Boolean(boot?.modules.includes('waiters')) &&
    printer.config.waiterBills &&
    printer.config.transport !== 'browser';
  const busy = useRef(false);
  const ctx = useRef({ boot, settings });
  ctx.current = { boot, settings };

  useEffect(() => {
    if (!on) return;
    let alive = true;
    const tick = async () => {
      if (busy.current || (typeof navigator !== 'undefined' && !navigator.onLine)) return;
      busy.current = true;
      try {
        const jobs = await withTimeout(deviceApi.rpc<Job[]>('pos_print_jobs', {}), 10_000);
        for (const j of jobs ?? []) {
          if (!alive) break;
          const { boot: b, settings: st } = ctx.current;
          if (!b) break;
          try {
            await printWaiterBill(j.order as unknown as Parameters<typeof printWaiterBill>[0], b, st);
            await deviceApi.rpc('pos_print_job_done', { p_job: j.id, p_ok: true });
          } catch (e) {
            await deviceApi
              .rpc('pos_print_job_done', { p_job: j.id, p_ok: false, p_error: e instanceof Error ? e.message : 'PRINT_FAILED' })
              .catch(() => undefined);
          }
        }
      } catch {
        // tarmoq yoki server — keyingi urinishda
      } finally {
        busy.current = false;
      }
    };
    void tick();
    const t = setInterval(() => void tick(), 5_000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, [on]);
  return null;
}
